module.exports = __webpack_public_path__ + "img/member_bottom03.96aba7dc.png";